import { useState, useEffect } from "react";

const getWidth = (className?: string): number => {
    if (className) {
        const el = document.querySelector<HTMLElement>(`.${className}`);
        return el ? el.offsetWidth : 0;
    }
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
};

const useCurrentWidth = (className?: string): number => {
    const [width, setWidth] = useState<number>(getWidth(className));

    useEffect(() => {
        if (className) {
            const el = document.querySelector<HTMLElement>(`.${className}`);
            if (!el) return;

            const observer = new ResizeObserver(() => {
                setWidth(el.offsetWidth);
            });

            observer.observe(el);

            return () => observer.disconnect();
        } else {
            // Fallback to window resize for whole window
            let timeoutId: NodeJS.Timeout | null = null;
            const resizeListener = (): void => {
                if (timeoutId) clearTimeout(timeoutId);
                timeoutId = setTimeout(() => setWidth(getWidth()), 150);
            };
            window.addEventListener("resize", resizeListener);

            return () => window.removeEventListener("resize", resizeListener);
        }
    }, [className]);

    useEffect(() => { console.log(width) }, [width])

    return width;
};

export default useCurrentWidth;
